__turbopack_context__.v({
  "className": "inter_d542793-module__-uZNGW__className",
  "variable": "inter_d542793-module__-uZNGW__variable",
});
